module.exports = __webpack_public_path__ + "media/images/lb/766-d5f40dbc22b181947f125554ec433f4b.svg";